"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpgradeabilityProxy__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_logic",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        stateMutability: "payable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        stateMutability: "payable",
        type: "fallback",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class UpgradeabilityProxy__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
        this.contractName = "UpgradeabilityProxy";
    }
    deploy(_logic, _data, overrides) {
        return super.deploy(_logic, _data, overrides || {});
    }
    getDeployTransaction(_logic, _data, overrides) {
        return super.getDeployTransaction(_logic, _data, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.UpgradeabilityProxy__factory = UpgradeabilityProxy__factory;
UpgradeabilityProxy__factory.bytecode = _bytecode;
UpgradeabilityProxy__factory.abi = _abi;
